import { Suspense, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';

import PageLoading from '@/components/Loaders/PageLoading';
import { saveAuthDetail } from '@/features/auth/authSlice';
import API from '@/services';
const RedirectToLogin = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get('token');

  const [loading, setLoading] = useState(false);

  const getUserInfo = async (token) => {
    try {
      const { data: res } = await API.getUser();
      setLoading(false);

      if (res) {
        if (res.login_count === -1) {
          navigate('/change-password');
        } else {
          dispatch(
            saveAuthDetail({
              access_token: token,
              user_id: res.id,
              email: res.email,
              first_name: res.first_name,
              last_name: res.last_name,
              date_created: res.date_created
            })
          );
          if (localStorage.getItem('save_url')) {
            window.location.replace(localStorage.getItem('save_url'));
          } else if (localStorage.getItem('save_previous_url')) {
            window.location.replace(localStorage.getItem('save_previous_url'));
            localStorage.removeItem('save_previous_url');
          } else {
            navigate('/');
          }
        }
      }
    } catch (error) {
      setLoading(false);
    }
  };

  // useEffect(() => {
  if (token) {
    console.log('token', token);
    dispatch(
      saveAuthDetail({
        access_token: token
      })
    );
    getUserInfo(token);
  }
  // }, []);

  return <Suspense fallback={<PageLoading loading />}>{children}</Suspense>;
};

export default RedirectToLogin;
